import React from "react";
import "./Accessdeniedmodal.css";

const AccessDeniedModal = ({ isOpen, deniedRole, availableRoles, onClose }) => {
  if (!isOpen) return null;

  const denied = deniedRole || "guest";
  const available = availableRoles?.length ? availableRoles.join(", ") : "host";

  const switchTarget = denied.toLowerCase() === "guest" ? "Guest" : "Host";

  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  const formatRoles = (roles) => {
    if (!roles || roles.length === 0) return "Host";

    const formatted = roles.map(capitalize);

    if (formatted.length === 1) return formatted[0];
    if (formatted.length === 2) return `${formatted[0]} or ${formatted[1]}`;

    return `${formatted.slice(0, -1).join(", ")} or ${formatted.slice(-1)}`;
  };

  const isHostDeniedAndUnavailable =
    denied?.toLowerCase() === "host" &&
    !availableRoles?.map((r) => r.toLowerCase()).includes("host");

  const loginText = formatRoles(availableRoles);

  const rolesCount = availableRoles?.length || 0;
  const roleLabel = rolesCount === 1 ? "role" : "roles";

  return (
    <div className="access-denied-overlay" onClick={onClose}>
      <div
        className="access-denied-container"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="access-denied-title">Access Denied</h2>
        <p className="access-denied-message">
          You cannot access this feature as &quot;{capitalize(denied)}&quot;.
          Your current available {roleLabel}: {capitalize(available)}
        </p>
        <p className="access-denied-switch-heading">
          👉 To switch to {switchTarget}:
        </p>
        <ol className="access-denied-steps">
          <li>Log in as {loginText}.</li>
          <li>Open the Account section.</li>
          <li>
            {isHostDeniedAndUnavailable
              ? "Request to be Host."
              : 'Select "Switch Account".'}
          </li>
        </ol>
        <button className="access-denied-ok-btn" onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedModal;
